export default "__VITE_ASSET__d09f0a8c__"